/**
 * Copia adaptada de apps/builder-spa/src/api/tenants.ts.
 * El customer SPA solo necesita listar y obtener el tenant propio (no
 * crear/editar — eso es responsabilidad del platform-ops admin SPA).
 */
import { apiFetch } from './apiClient.js';

export interface Tenant {
  id: string;
  slug: string;
  name: string;
  tier: 'logical' | 'physical';
  status?: 'active' | 'suspended' | 'pending';
  defaultLocale?: string;
  featureFlags?: Record<string, boolean>;
  version?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface ListTenantsResult {
  items: Tenant[];
  nextToken?: string;
}

export async function listTenants(
  opts: { limit?: number; nextToken?: string; status?: Tenant['status'] } = {},
): Promise<ListTenantsResult> {
  const qs = new URLSearchParams();
  if (opts.limit) qs.set('limit', String(opts.limit));
  if (opts.nextToken) qs.set('nextToken', opts.nextToken);
  if (opts.status) qs.set('status', opts.status);
  const suffix = qs.toString() ? `?${qs}` : '';
  return apiFetch<ListTenantsResult>(`/v1/tenants${suffix}`);
}

export async function getTenant(id: string): Promise<Tenant> {
  return apiFetch<Tenant>(`/v1/tenants/${encodeURIComponent(id)}`);
}

export type TenantPatch = Partial<
  Pick<Tenant, 'name' | 'defaultLocale' | 'featureFlags'>
>;

/**
 * PATCH /v1/tenants/{id} con If-Match optimistic concurrency.
 * El backend valida que el caller sea platform-ops o admin del tenant.
 * Tier y status NO son editables desde el customer-spa por design.
 */
export async function updateTenant(
  id: string,
  patch: TenantPatch,
  ifMatchVersion: number,
): Promise<Tenant> {
  return apiFetch<Tenant>(`/v1/tenants/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: patch,
    headers: { 'If-Match': String(ifMatchVersion) },
  });
}
